import React from "react"
import { TableHeaderColumn } from "react-bootstrap-table"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SingleSelectTable from "../../fragments/SingleSelectTable"
import UIAvatar from "../../fragments/UIAvatar"
import { connect } from "react-redux"
import { Link, browserHistory } from "react-router"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { Button, Col, Row } from "react-bootstrap"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import InvestorCard from "./Card"
import { CardType, sortDate } from "../../../lib/utils"

class ListInvestors extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()
  isAdminOrAccountant = this.isAdmin || this.authenticated.isAccountant()

  state = {
    selectedRow: null,
    isSelected: false,
  }

  componentDidMount() {
    this.props.loadData()
  }

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.bankName.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
  }

  itemSelected = (selectedRow, isSelected) => this.setState({
    selectedRow,
    isSelected
  })

  getElementById = (id, data) => data.find(item => item.id === id)

  updateLink = id => `/financiers/investors/${id}/update`

  detailsLink = id => `/financiers/investors/${id}/detail`

  renderDetailLink = (id, content) =>
    <Link to={ this.detailsLink(id) } className="p-5">
      { content }
    </Link>

  renderUpdateLink = id => {

    if(!this.isAdmin) return null
    return (
      <Link to={ this.updateLink(id) } className="p-5">
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  renderGoToPayments = () => {

    const goToPayments = <Button bsStyle="info"
      onClick={() => browserHistory.push('/financiers/investors/payments')}>
      <FontAwesome name='dollar' /> Investor Payments
    </Button>

    return [ goToPayments ]
  }

  renderTable = investors => (
    <SingleSelectTable
      items={ investors }
      addNewLabel="Add Investor"
      addNewHandler={() => browserHistory.push('/financiers/investors/create')}
      exportCSV={ this.isAdminOrAccountant }
      csvFileName='investors.csv'
      shouldRenderToolbar={ this.isAdminOrAccountant }
      itemSelected={ this.itemSelected }
    >
      <TableHeaderColumn
        dataField="id"
        isKey
        dataAlign="center"
        dataFormat={(_, { name }) => <UIAvatar name={ name } size={ 28 } />}
        csvHeader="Investor ID"
        width='48'
      />

      <TableHeaderColumn
        ref='name'
        dataField="name"
        dataSort
        dataAlign="center"
        filter={{ type: "TextFilter", delay: 1000 }}
        dataFormat={(_, { id, name }) => this.renderDetailLink(id, name)}
        csvHeader="Name"
        columnClassName="min-w-120"
      >
        Name
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='bankName'
        dataField="bankName"
        dataSort
        dataAlign="center"
        filter={{ type: "TextFilter", delay: 1000 }}
        csvHeader="Bank name"
        columnClassName="min-w-120"
      >
        Bank name
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='createdOnFormatted'
        dataField="createdOnFormatted"
        dataAlign="center"
        dataSort
        sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
        filter={{ type: "DateFilter", delay: 1000 }}
        csvHeader="Created On"
        columnClassName='text-xs'
        width="140"
      >
        Created On
      </TableHeaderColumn>

      <TableHeaderColumn
        dataAlign="center"
        width="80px"
        dataFormat={(_, { id }) =>
        <span className="flex-detail">
          { this.renderDetailLink(id, <FontAwesome name="eye" title='Details' />) }
          { this.renderUpdateLink(id) }
        </span>}
      />
    </SingleSelectTable>
  )

  render() {
    const { investors, setInvestor, removeInvestor } = this.props,

    { selectedRow, isSelected } = this.state,

    investor = selectedRow ? this.getElementById(selectedRow.id, investors) : null,

    meetCond = isSelected && !!investor

    return (
      <div>
        <CustomBreadCrumb activeText='Investors' data={ [{ url: '/financiers', title: 'Financiers' }] } />

        <Row>
          <Col md={ meetCond ? 8 : 12 }>
            <ClearFiltersButton onClick={ this.doClearFilters } others={ this.renderGoToPayments() } />
            { this.renderTable(investors) }
          </Col>

          { meetCond &&
            <Col md={4}>
              <InvestorCard
                investor={ investor }
                setInvestor={ setInvestor }
                removeInvestor={ removeInvestor }
                cardType={ CardType.SMALL }
              />
            </Col>
          }
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const investors = DckSelectors.selectAllItems(state, ItemTypes.Investor)
  return { investors }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Investor)),
  setInvestor: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Investor, id, data)),
  removeInvestor: id => dispatch(DckActionCreators.itemRemove(ItemTypes.Investor, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListInvestors)



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/List.js